import Image from "next/image";

export function ChoiceCard({
  selected,
  onClick,
  icon,
  title,
  body,
  compact,
}: {
  selected: boolean;
  onClick: () => void;
  icon?: string;
  title: string;
  body?: string;
  compact?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      className={`relative flex cursor-pointer flex-col gap-2.5 rounded border-2 text-left transition-colors ${
        compact ? "p-5" : "p-6"
      } ${
        selected ? "border-theme-accent bg-[#F9FBF4]" : "border-border bg-white hover:border-ink"
      }`}
    >
      {icon ? (
        <div
          className={`hidden sm:flex items-center justify-center ${compact ? "h-10 w-10" : "h-13 w-13"}`}
        >
          <Image
            src={icon}
            alt=""
            width={compact ? 40 : 52}
            height={compact ? 40 : 52}
            className="h-full w-full object-contain"
          />
        </div>
      ) : (
        <div
          className={`hidden sm:flex items-center justify-center font-serif text-3xl text-ink-muted ${
            compact ? "h-10 w-10" : "h-13 w-13"
          }`}
        >
          ?
        </div>
      )}
      <h3
        className={`font-serif font-bold tracking-[-0.01em] text-ink ${
          compact ? "text-[15px] leading-snug" : "text-xl"
        }`}
      >
        {title}
      </h3>
      {body && <p className="text-[13px] leading-relaxed text-ink-muted">{body}</p>}
      {selected && (
        <span
          aria-hidden
          className="absolute top-3.5 right-3.5 flex h-6 w-6 items-center justify-center rounded-full bg-theme-accent text-[13px] font-semibold text-white"
        >
          ✓
        </span>
      )}
    </button>
  );
}
